export interface User {
    name: string;
    email: string;
    phone: string;
    website: string;
}

export interface UploadedFile {
    id: number;
    agency: string;
    uploadedBy: string;
    uploadDate: string;
    fileName: string;
    submissionPeriod: string;
    status: string;
}

export interface Ori {
    ori: string;
    agency: string;
    label: string;
    oriAgency: string;
}

export interface UploadedFileDetails {
    id: number;
    ori: string;
    createdOn: string;
    createdBy: string;
    source: string;
    processedOn: string;
    fileName: string;
    errorCode: string;
    errorCount: number;
    errorMessage: string;
    status: string;
    statusLabel: string;
    warningCount: number;
    errorsAndWarnings: UploadedFileWarningsAndErrors[];
    fileStatistics: FileStatistics[];
    failedFileDetails: FailedFileDetails[];
}

export interface FailedFileDetails {
    lineNumber: number;
    errorCode: string;
    description: string;
}

export interface FetchValidationMessagesResponse {
    total: number;
    validationMessages: FailedFileDetails[];
}

export interface UploadedFileWarningsAndErrors {
    agency: string;
    ori: string;
    "incidentNumber": string;
    "stopNumber": string;
    "lineNumber": string;
    "errorCode": string;
    type: string;
    description: string;
    isZeroReport: boolean;
}

export interface VItem {
    text: string;
    value: any;
    [x: string]: any;
}

export interface FileStatistics {
    type: string;
    submitted: number;
    rejected: number;
    rejectionRate: number;

}

export interface SelectItem {
    label: string;
    value: any;
    isDisable: boolean;
}

export type SelectValue = {
    value: any;
};

export interface AgeRange {
    upper: number;
    lower: number;
}

export interface SelectorMode {
    type: SelectEntryType;
    label: string;
    isDefaultSelection: boolean;
}

export enum SelectEntryType {
    Add = "add",
    Edit = "edit",
    Zero = "zero",
    Delete = "delete"
}

export enum UploadType {
    nibrs,
    summary,
    useOfForce,
    narrative,
    policeEmployee,
    contacts,
    communityPolicing,
    population
}

export interface QueueQueryResult {
    total: number;
    pageNumber: number;
    itemsPerPage: number;
    data: QueueItem[];
}

export interface QueueItem {
    status: string;
    type: string;
    start: Date;
    end: Date;
}
export interface AgencyType {
    code: string;
    label: string;
}

export interface PopulationProfile {
    profileName: string;
    loaderType: number;
    options: string;
    excludedAgencyTypes: string[];
}


export interface UserOri {
    allowUpload: boolean;
    ori: string;
}

export interface UserInformation {
    userId: number;
    userName: string
    password: string;
    confirmPassword: string;
    firstName: string;
    lastName: string;
    organization: string;
    email: string;
    roleId: number;
    oris: UserOri[];
    custom1: string;
    custom2: string;
    custom3: string;
    apiKey: string;
    isEnabled: boolean;
}


export interface Role {
    roleId: number
    roleName: string;
    defaultFlag: boolean;
}


export interface UserField {
    fieldName: string
    visible: boolean;
    required: boolean;
    editable: boolean;
    label: string;
    visibleEnabled: boolean;
    requiredEnabled: boolean;
    editableEnabled: boolean;
}

export interface GenerateApiKeyResponse {
    targetControl: string;
    apiKey: string;
}



export interface DatasetSummary {
    error_count: number
    warning_count: number
}

export interface DatasetStatisticsSummary {
    type_id: number
    type_name: string
    reports_processed: number
    reports_rejected: number
    error_rate: number
    outstanding_rejections: number
    outstanding_error_rate: number
}

export interface DatasetLastSubmission {
    upload_date: string
    file_name: string
    uploaded_by: string
    total_records: number
    rejected: number
    error_rate: number
}

export interface Notice {
    id: number
    ori: string
    is_displayed: boolean
    is_dismissed: boolean
    header?: string
    message?: string
    email: any
    send_date: string
    expiry_date: string
    NotificationLogId: number
    RunDate: string
    EmailType: number
}

export interface AgencyDashboard {
    periods: Period[]
    datasets: Dataset[]
}

export interface Period {
    code: number
    label: string
}

export interface Dataset {
    code: number
    label: string
}


export interface AgencyPopulation {
    year: number
    employee_population: number
}

export interface AgencyStaffing {
    year: number
    sworn_in_male: number
    sworn_in_female: number
    civilian_male: number
    civilian_female: number
}

export interface Tab {
    id:string,
    name:string
}